
/**
 * Creates a responsive srcset for an image
 */
export function createSrcSet(
  baseUrl: string,
  widths: number[] = [320, 640, 768, 1024, 1280, 1536],
  extension?: string
): string {
  if (!baseUrl) return '';

  // Don't process external URLs or data URLs
  if (baseUrl.startsWith('http') || baseUrl.startsWith('data:')) {
    return baseUrl;
  }

  // Handle file extension replacement
  return widths
    .map(width => {
      const url = extension
        ? baseUrl.replace(/\.\w+$/, `-${width}w.${extension}`)
        : baseUrl.replace(/\.\w+$/, `-${width}w$&`);
      return `${url} ${width}w`;
    })
    .join(', ');
}

/**
 * Creates sizes attribute for responsive images
 */
export function createSizes(sizes: { mediaQuery?: string; size: string }[] = []): string {
  if (sizes.length === 0) {
    // Default responsive sizes
    return '(min-width: 1280px) 33vw, (min-width: 768px) 50vw, 100vw';
  }

  return sizes
    .map(({ mediaQuery, size }) => (mediaQuery ? `${mediaQuery} ${size}` : size))
    .join(', ');
}

/**
 * Generates both WebP and original format srcset
 */
export function generateResponsiveImageSets(
  baseUrl: string,
  widths: number[] = [320, 640, 768, 1024, 1280, 1536]
): { srcset: string; webpSrcset: string; fallback: string } {
  return {
    srcset: createSrcSet(baseUrl, widths),
    webpSrcset: createSrcSet(baseUrl, widths, 'webp'),
    fallback: baseUrl,
  };
}
